export enum SbEventTopic {
    TabPanelTabChange = 'TabPanelTabChange',
    AccountSelected = 'AccountSelected',
    ReloadAccounts = 'ReloadAccounts',
    FormFiltered = 'FormFiltered',
    Print = 'Print',
    UserIdle = 'UserIdle',
    ConnectionStatus = 'ConnectionStatus',
    BaseCurrencySelected = 'BaseCurrencySelected',
    TableRowSelected = 'TableRowSelected',
    CompanySelected = 'CompanySelected',
    TransactionSubmitted = 'TransactionSubmitted',
    InstrumentSubmitted = 'InstrumentSubmitted',
    GridDataSet = 'GridDataSet',
    DisplayOutputSet = 'DisplayOutputSet'
}
